// export const BACKEND_URL = process.env.REACT_APP_API_BASE_URL || 'https://api1.sanoft.com/api';
// export const BACKEND_URL = 'https://yscloud.in/backend/api';
export const BACKEND_URL = process.env.REACT_APP_API_BASE_URL || 'https://api-pos-legacy-uat.sanoft.com/api';

export const STORAGE_KEYS = {
  TOKEN: 'x-auth-token',
  USER_ID: 'x-auth-user-id',
  FIRST_NAME: 'x-first-name',
  LAST_NAME: 'x-last-name',
  USERNAME: 'x-username',
};

export const HEADERS = {
  AUTH: 'Authorization',
};

export const ROUTES = {
  LOGIN: '/login',
  RESET_PASSWORD: '/reset-password',
  ANY: '/',
  CONSOLE: '/console',

  SHOPS: '/console/shops',
  NEW_SHOP: '/console/new-shop',
  EDIT_SHOP: '/console/shops/:shopId',
  REGISTRATION_KEY: '/console/registration-keys',
  NEW_REGISTRATION_KEY: '/console/registration-keys/new-key',
  EDIT_REGISTRATION_KEY: '/console/registration-keys/:keyId',
  CREATE_TERMINAL: '/console/shops/:shopId/terminal',
  PAGE_404: '/page-404',
  RENEWALS: '/console/renew-shops',
};

export const GST_PREFERENCES = [
  { name: 'Non GST', id: 0 },
  { name: 'Excluding GST', id: 1 },
  { name: 'Including GST', id: 2 },
];

const DEFAULT_SUBSCRIPTIONS = {
  32: 'POS Lite India',
  33: 'POS Pro India',
  34: 'POS Elite India',
  30: 'POS Lite US',
  29: 'POS Pro US',
  28: 'POS Elite US',
  1: 'Sanoft Lite',
  2: 'Premium',
  4: 'Standard',
  22: 'Standard 12000 Sales',
  25: 'Standard 18000 Sales',
  18: 'Standard 24000 Sales',
  57: 'Standard 7000 Sales',
};

const parseJsonEnvVar = (envVar, defaultValue) => {
  if (process.env[envVar]) {
    try {
      return JSON.parse(process.env[envVar]);
    } catch (e) {
      console.error(`Failed to parse ${envVar} JSON:`, e);
    }
  }
  return defaultValue;
};

export const SUBSCRIPTIONS = parseJsonEnvVar('REACT_APP_SUBSCRIPTIONS', DEFAULT_SUBSCRIPTIONS);

const DEFAULT_SUBSCRIPTION_KEYS = {
  32: 'sanoft-lite',
  33: 'sanoft-pro',
  34: 'sanoft-elite',
  30: 'sanoft-lite',
  29: 'sanoft-pro',
  28: 'sanoft-elite',
  1: 'sanoft-lite',
  2: 'premium',
  4: 'standard',
  22: 'standard_12000_sales',
  25: 'standard_18000_sales',
  18: 'standard_24000_sales',
  57: 'standard_7000_sales',
};

export const SUBSCRIPTION_KEYS = parseJsonEnvVar('REACT_APP_SUBSCRIPTION_KEYS', DEFAULT_SUBSCRIPTION_KEYS);

const DEFAULT_SUBSCRIPTION_IDS = {
  'sanoft-lite': 1,
  'sanoft-pro': 26,
  'sanoft-elite': 27,
  premium: 2,
  standard: 4,
  standard_12000_sales: 22,
  standard_18000_sales: 25,
  standard_24000_sales: 18,
  standard_7000_sales: 57,
};

export const SUBSCRIPTION_IDS = parseJsonEnvVar('REACT_APP_SUBSCRIPTION_IDS', DEFAULT_SUBSCRIPTION_IDS);

export const SUBSCRIPTION_OPTIONS = [
  { id: 32, key: 'sanoft-lite', country: 'IN' },
  { id: 33, key: 'sanoft-pro', country: 'IN' },
  { id: 34, key: 'sanoft-elite', country: 'IN' },

  { id: 30, key: 'sanoft-lite', country: 'US' },
  { id: 29, key: 'sanoft-pro', country: 'US' },
  { id: 28, key: 'sanoft-elite', country: 'US' },

  { id: 1, key: 'sanoft-lite' },
  { id: 2, key: 'premium' },
  { id: 4, key: 'standard' },
  { id: 22, key: 'standard_12000_sales' },
  { id: 25, key: 'standard_18000_sales' },
  { id: 18, key: 'standard_24000_sales' },
  { id: 57, key: 'standard_7000_sales' },
];

export const DEALERS = {
  1: 'Scangle',
  2: 'Dubai',
  3: 'Oman',
  4: 'Sanoft',
  5: 'ALT',
  6: 'Dynamic',
  7: 'Saudi',
  8: 'Trass India',
  10: 'Yesweigh',
  11: 'Kraus',
  12: 'Elmass',
  13: 'HMS',
  14: 'Meezan',
  15: 'Venkatachalam',
  16: 'Victory',
  23: 'Bahrain',
};

export const CURRENCIES = ['₹', 'RO', 'AED', 'SAR'];

export const TERMINAL_TYPES = { pos_terminal: 'POS', ecs_terminal: 'ECS', pos_windows_terminal: 'POS Windows Terminal', pos_web_terminal: 'POS Web Terminal' };

export const ADDITIONAL_SALES = [
  { key: 'additional_sales_1', price: 0, sale_count: 1, count: 1 },
  { key: 'additional_sales_3000', price: 300, sale_count: 3000, count: 1 },
  { key: 'additional_sales_6000', price: 500, sale_count: 6000, count: 1 },
];

export const MONTHLY_SUB_PERIOD = 30;
export const YEARLY_SUB_PERIOD = 365;

export const COUNTRY_CONFIGRATION = {
  IN: { name: 'India', currency: '₹', code: 'IN', tax: 0.18 },
  SA: { name: 'Saudi Arabia', currency: 'SAR', code: 'SA', tax: 0 },
  OM: { name: 'Oman', currency: 'OMR', code: 'OM', tax: 0 },
  AE: { name: 'UAE', currency: 'AED', code: 'AE', tax: 0 },
  US: { name: 'US', currency: '$', code: 'US', tax: 0 },
};

export const DEFAULT_COUNTRY = 'US';

export const DEFAULT_CURRENCY = '₹';

export const REGISTRATION_TYPE = {
  NEW: 'new-shop',
  TRIAL: 'trial-shop',
  RENEWAL: 'renew-shop',
};

export const ADDONS = {
  kot: 'kot_validity',
  image: 'image_support_validity',
  smart_scale: 'smart_scale_validity',
  bluetooth_scale: 'bluetooth_scale_validity',
  customer: 'customer_support_validity',
  external_api: 'quickbook_support_validity',
  pos_terminal: 'pos',
  ecs_terminal: 'ecs',
};

export const SHOP_STATUS_MAP = {
  active: 'Active',
  trial: 'Trial',
  'delete-requested': 'Delete Requested',
};
